module.exports = __webpack_public_path__ + "static/media/lexus-minus.d315f31e.svg";